import type { NetworkToken } from '@shared/types/network-token.types'

const STATUSES = ['active', 'active', 'active', 'active', 'suspended', 'deleted', 'expired'] as const
const NETWORKS = ['Visa', 'Mastercard', 'Amex', 'Discover'] as const
const TOKEN_BINS = ['4900', '5123', '3742', '6011', '4111', '5500', '3782', '6221']
const CARD_BINS = ['4532', '5412', '3456', '6543', '4716', '5234', '3789', '6012']
const MERCHANTS = [
  { id: 'mch_001', name: 'Acme Corp' },
  { id: 'mch_002', name: 'TechFlow Inc' },
  { id: 'mch_003', name: 'Global Retail' },
  { id: 'mch_004', name: 'FastPay Services' },
  { id: 'mch_005', name: 'Digital Commerce' },
]

function randomItem<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]
}

function randomLast4(): string {
  return String(Math.floor(1000 + Math.random() * 9000))
}

function randomExpiration(): string {
  const month = String(Math.floor(1 + Math.random() * 12)).padStart(2, '0')
  const year = 2025 + Math.floor(Math.random() * 5)
  return `${month}/${year}`
}

function randomDate(daysBack: number): string {
  const date = new Date()
  date.setDate(date.getDate() - Math.floor(Math.random() * daysBack))
  return date.toISOString()
}

export const mockNetworkTokens: NetworkToken[] = Array.from({ length: 48 }, (_, i) => {
  const merchant = randomItem(MERCHANTS)
  return {
    id: `ntk_${String(i + 1).padStart(4, '0')}`,
    status: randomItem(STATUSES),
    tokenBin: randomItem(TOKEN_BINS),
    tokenLast4: randomLast4(),
    tokenExpiration: randomExpiration(),
    cardBin: randomItem(CARD_BINS),
    cardNetwork: randomItem(NETWORKS),
    tokenProvisioned: randomDate(180),
    merchantId: merchant.id,
    merchantName: merchant.name,
  }
})
